export const flattenDTO = (data, isRoot = false) => {
    let flattened = {};

    if (data?.predicates?.length) {
        data?.predicates.forEach((predicate) => {
            flattened = {
                ...flattened,
                ...flattenDTO(predicate)
            };
        });
    }

    if (data?.predicateParts?.length) {
        data?.predicateParts.forEach((predicatePart) => {
            flattened = {
                ...flattened,
                ...flattenDTO(predicatePart)
            };
        });
    }

    if (data?.uuid) {
        flattened[data.uuid] = data;

        if (flattened[data.uuid]?.predicates?.length && typeof flattened[data.uuid]?.predicates[0] !== 'string') {
            flattened[data.uuid].predicates = (data?.predicates ?? [])
                .sort((a, b) => a.predicateOrder - b.predicateOrder)
                .map(({ uuid } = {}) => uuid ?? null)
                .filter(Boolean);
        }
        if (
            flattened[data.uuid]?.predicateParts?.length &&
            typeof flattened[data.uuid]?.predicateParts[0] !== 'string'
        ) {
            flattened[data.uuid].predicateParts = (data?.predicateParts ?? [])
                .sort((a, b) => a.predicatePartOrder - b.predicatePartOrder)
                .map(({ uuid } = {}) => uuid ?? null)
                .filter(Boolean);
        }
    }

    return flattened;
};
